import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '../../components';

// Afbeeldingen importeren
import coverborstvoedingsbabbelouders from '../../assets/images/podcast/covers/coverborstvoedingsbabbelouders.png';
import coverborstvoedingsbabbelzorgprofessionals from '../../assets/images/podcast/covers/coverborstvoedingsbabbelzorgprofessionals.png';

export default function PodcastHome() {
    const navigate = useNavigate();

    const cardStyle = {
        width: '350px',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        
    };

    const imgStyle = {
        width: '100%',
        borderRadius: '20px',
        marginBottom: '1vw',
        boxShadow: '0 4px 15px rgba(0,0,0,0.15)'
        
    };

    return (
        <div style={{ 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '5vw'
        }}>
            
            <Typography type="h1" style={{ color: '#92320F', marginBottom: '3vw' }}>
                Borstvoedingsbabbel Podcasts
            </Typography>
            <Typography type="h2" style={{ color: '#92320F', marginBottom: '5vw', maxWidth: '600px', textAlign: 'center' }}>
                Voor ouders én zorgprofessionals
            </Typography>

            <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '3vw',
                flexWrap: 'wrap'
            }}>

                {/* Ouders card */}
                <div 
                    style={cardStyle}
                    onClick={() => navigate('/podcast/ouders')}
                >
                    <img 
                        src={coverborstvoedingsbabbelouders} 
                        alt="Borstvoedingsbabbel voor Ouders" 
                        style={imgStyle}
                    />
                    
                </div>

                {/* Zorgprofessionals card */}
                <div 
                    style={cardStyle}
                    onClick={() => navigate('/podcast/zorgprofessionals')}
                >
                    <img 
                        src={coverborstvoedingsbabbelzorgprofessionals} 
                        alt="Borstvoedingsbabbel voor Zorgprofessionals" 
                        style={imgStyle}
                    />
                    
                </div>

            </div>
        </div>
    );
}